import {Component, OnInit}    from "@angular/core";
import {SchemaSettings}       from "./components/schema.models";
import {ActivatedRoute}       from '@angular/router';
import {Schema}               from '../shared/api/bases/proxy/schemas/schema.interface';
import {Base}                 from '../shared/api/bases/api.models';

@Component({
    selector : 'add-schema',
    template: require('./add.component.html')
})

export class AddSchemaComponent implements OnInit {
    public base: Base;
    public schema: Schema;
    public settings: SchemaSettings;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.settings = new SchemaSettings();
        this.base     = this.route.snapshot.data['base'];
        this.schema   = {
            id:                null,
            name:              '',
            nextSchemaId:      null,
            priority:          100,
            duration:          1,
            hasEverBeenActive: false,
            created:           '',
            modified:          '',
            isActive:          false,
            metadata:          {},
            profileFilters:    {}
        } as Schema;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/add.component.ts